import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Body from "src/components/common/Body";
import Box from "src/components/common/Box";
import Button from "src/components/common/Button";
import IconButton from "src/components/common/IconButton";
import SVG from "src/utils/SVG";
import SearchInput from "src/components/common/SearchInput";
import ShopItem from "src/components/manage/ShopItem";
import ComItem from "src/components/manage/ComItem";
import List from "src/components/common/List";
import styled from "styled-components";
import BottomModal, { RefProps } from "src/components/common/BottomModal";
import GroupProcessItem from "src/components/filter/GroupProcessItem";
import { useDeleteGroupMutation, useSelectGroupStoreQuery } from "src/api/userAPI";
import { getPathValue } from "src/utils/queryStringUtil";
import PaginationCommon from "src/components/common/PaginationCommon";
import { isEmpty } from "lodash";
import setQueryStringVer from "src/utils/reuseQueryString";

function manageGroup() {
  const navigate = useNavigate();
  const processModalRef = React.useRef<RefProps>(null);

  const openProcessModal = () => {
    if (processModalRef.current) processModalRef.current.modalOpen();
  };

  // ==================================== 퍼블리싱 영역 끝 ====================================

  const group_index: any = getPathValue();
  const navigateState = useLocation();

  // 초기 값 세팅 영역
  const [navigateStateDate, setNavigateStateData] = useState<any>(navigateState.state);

  const [apiSkip, setApiSkip] = useState(true);

  const [queryString, setQueryString] = useState({
    pageSearchNumber: 1,
    contentsSearchString: "",
  });

  const [filterData, setFilterData] = useState<string>();

  const [totalPages, setTotalPages] = useState<number | undefined>();
  const [init, setInit] = useState({
    currentPage: 0,
  });
  const { currentPage } = init;
  const [searchContents, setSearchContents] = useState<string>();

  // API 영역
  const groupStoreAPI = useSelectGroupStoreQuery({ groupId: group_index, queryString: filterData }, { skip: apiSkip });

  const [deleteGroupAPI, { isError, isSuccess, isLoading }] = useDeleteGroupMutation();

  // 생명주기 영역

  useEffect(() => {
    if (groupStoreAPI.isSuccess) {
      setTotalPages(groupStoreAPI.data.meta.totalPages);
      // setCurrentPage(groupStoreAPI.data.meta.currentPage);
      setInit({
        ...init,
        currentPage: groupStoreAPI.data.meta.currentPage,
      });
    }
  }, [groupStoreAPI]);

  useEffect(() => {
    if (group_index) {
      setApiSkip(false);
    }
  }, [group_index]);

  useEffect(() => {
    if (isSuccess) {
      alert("그룹을 삭제하였습니다.");
      navigate("/manage-list");
    }
  }, [isSuccess]);

  useEffect(() => {
    const filter = setQueryStringVer(queryString);
    setFilterData(filter);
    setApiSkip(false);
  }, [queryString]);

  // event 영역
  const deleteGroup = async () => {
    if (window.confirm("그룹을 정말 삭제하시겠습니까?")) {
      await deleteGroupAPI({ groupId: group_index });
    }
  };

  const objectChange = (page: number) => {
    setQueryString({
      ...queryString,
      pageSearchNumber: page,
    });
  };

  const groupStoreSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setSearchContents(value);
  };

  const onKeyPress = (e: any) => {
    if (e.key === "Enter") {
      searchContentsBtn(e);
    }
  };

  const searchContentsBtn = (e: any) => {
    const contents = e.currentTarget.parentElement?.childNodes[0].value;
    setSearchContents(contents);
    setQueryString({
      ...queryString,
      contentsSearchString: contents!,
      pageSearchNumber: 1,
    });
  };

  const deleteSearchContents = () => {
    setInit({
      ...init,
      currentPage: 1,
    });
    setSearchContents("");
    setQueryString({
      ...queryString,
      pageSearchNumber: 1,
      contentsSearchString: "",
    });
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
            {navigateStateDate.groupName}
          </Button>
        </div>
        {navigateStateDate.groupName === "백화점" || navigateStateDate.groupName === "대리점" || navigateStateDate.groupName === "직영점" ? (
          ""
        ) : (
          <div className="btn-box">
            <IconButton btnName="편집팝업 버튼" className="more" onClick={openProcessModal}>
              <SVG name="more" />
            </IconButton>
          </div>
        )}
      </header>

      <Body>
        <Box pd="20px 15px">
          <SearchInput
            type="text"
            id="group-store-search"
            placeholder="매장 또는 업체명을 입력해주세요."
            defaultValue={searchContents}
            onKeyPress={onKeyPress}
            onClick={(e) => searchContentsBtn(e)}
            deleteSearchContentFunc={deleteSearchContents}
            // onChange={(e) => {
            //   groupStoreSearch(e);
            // }}
          />
        </Box>

        {groupStoreAPI.isSuccess && groupStoreAPI.data.data.length > 0 && (
          <TotalNumberSet>
            총 <span>{groupStoreAPI.isSuccess ? groupStoreAPI.data.meta.totalItems : ""}</span>개
          </TotalNumberSet>
        )}

        <List pd="0 15px" itemPd="25px 0">
          {groupStoreAPI.isSuccess && groupStoreAPI.data.data.length > 0 ? (
            <ShopItem registeredAPIdata={groupStoreAPI.isSuccess ? groupStoreAPI : ""} />
          ) : (
            <NoResult>리스트 결과가 없습니다.</NoResult>
          )}
          <ComItem />
        </List>
        {totalPages !== undefined && totalPages > 1 && (
          <PaginationCommon
            item_count={10}
            current_page={currentPage}
            total_page={totalPages}
            objectChange={(p: number) => objectChange(p)}
            viewName="manage"
          />
        )}
      </Body>

      <BottomModal modalTitle="그룹관리" ref={processModalRef}>
        <List pd="0 15px">
          <GroupProcessItem groupName={navigateStateDate.groupName} onClick={() => deleteGroup()} />
        </List>
      </BottomModal>
    </>
  );
}

const TotalNumberSet = styled.p`
  padding: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  color: ${({ theme }) => theme.color.secondary};
  text-align: right;
`;

const NoResult = styled.li`
  margin: 80px 0 40px;
  text-align: center;
`;

export default manageGroup;
